import { i18n } from '../../../../language';
import { authNameE } from '../../../../utils/userFuncs';
import Base from './Base';

const WardToolBar = ({ searchClick, addClick, onChange, roleMap }) => {
  const props = {
    addTitle: roleMap[authNameE.setting_create_ward] ? i18n.t('SETTING_ADD_WARD') : null,
    searchPlace: i18n.t('SETTING_WARD_NAME'),
    searchClick,
    addClick,
    onChange,
  };
  return <Base {...props} />;
};

const RoleToolBar = ({ searchClick, addClick, onChange, roleMap }) => {
  const props = {
    addTitle: roleMap[authNameE.setting_create_role] ? i18n.t('SETTING_ADD_WARD') : null,
    searchPlace: i18n.t('SETTING_ROLE_NAME'),
    searchClick,
    addClick,
    onChange,
  };
  return <Base {...props} />;
};

// selectList => [] => {} => id, itemList, value, onChange
const UserToolBar = ({ searchClick, addClick, selectList, onChange, pageSize }) => {
  const selects = [
    { placeholder: i18n.t('SETTING_STATUS') },
    { placeholder: i18n.t('SETTING_ROLE_NAME') },
    { placeholder: i18n.t('SETTING_HOSPITAL_NAME'), allowInput: true },
    { placeholder: i18n.t('SETTING_WARD_NAME'), allowInput: true },
  ];
  const props = {
    addTitle: i18n.t('SETTING_ADD_USER'),
    searchPlace: i18n.t('SETTING_CORP_ID'),
    selectList:
      Array.isArray(selectList) &&
      selectList.map((item, index) => {
        return { ...item, ...selects[index] };
      }),
    searchClick,
    addClick,
    onChange,
    pageSize,
  };
  return <Base {...props} />;
};

const ChatroomCategoryToolBar = ({ searchClick, addClick, selectList, onChange, pageSize }) => {
  const selects = [
    { placeholder: i18n.t('SETTING_HOSPITAL_NAME'), allowInput: true },
    { placeholder: i18n.t('SETTING_WARD_NAME'), allowInput: true },
  ];
  const props = {
    addTitle: i18n.t('SETTING_ADD'),
    searchPlace: i18n.t('DUTYASSIGN_STAFF_FILTER'),
    selectList:
      Array.isArray(selectList) &&
      selectList.map((item, index) => {
        return { ...item, ...selects[index] };
      }),
    addClick,
    onChange,
    pageSize,
  };
  return <Base {...props} />;
};

export { WardToolBar, RoleToolBar, UserToolBar, ChatroomCategoryToolBar };
